<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站名称:" :label-width="100">
				<Input type="text" v-model="formInline.StationName" placeholder="充电站名称" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('addStation')" v-if="hasWidgets('add')">场站添加</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getStationInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal :mask-closable="false" @on-cancel="cancelPictures" v-model="modalView" :title="modal.Title" width="60%">
			<!--设备安装和设备修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='addStation'||modal.type=='updateStation'||modal.type=='viewStation'" ref="StationForm"
				:model="StationForm" :label-width="150">
				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="场站编码" prop="StationCode" v-show="false">
						<Input :disabled="ifup" v-model="StationForm.StationCode" placeholder="输入场站编码"></Input>
					</FormItem>
					<FormItem label="充电站名称" prop="StationName">
						<Input :disabled="ifViewStation" v-model="StationForm.StationName" placeholder="输入充电站名称"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="运营商ID" prop="OperatorId" v-show="false">
						<Input :disabled="ifAddStation" v-model="StationForm.OperatorId" placeholder="输入运营商ID"></Input>
					</FormItem>
					<FormItem label="所属运营商" prop="OperatorName">
						<!-- <Input v-model="StationForm.OperatorName" placeholder="输入运营商名称"></Input> -->
						<Select :disabled="ifViewStation" @on-change="OperatorNameChange" placeholder="运营商名称"
							v-model="StationForm.OperatorName">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatortypeList" :value="item.Name">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="场站图片" prop="StationCode">
						<div class="demo-upload-list" :key="item.uid" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" :disabled="ifViewStation" :headers="upHeader" :show-upload-list="false"
							:default-file-list="defaultList" :on-success="handleSuccess" name="UpFile" :format="['jpg','jpeg','png']"
							:max-size="2048" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize"
							:before-upload="handleBeforeUpload" multiple type="drag" :action="uploadImageUrl"
							style="display: inline-block;width:58px;">
							<div style="width: 58px;height:58px;line-height: 58px;">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
						<Modal title="View Image" v-model="visible">
							<img :src="imgName" v-if="visible" style="width: 100%">
						</Modal>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="服务电话" prop="ServiceTel">
						<Input :disabled="ifViewStation" v-model="StationForm.ServiceTel" placeholder="输入服务电话"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="负责人电话" prop="StationTel">
						<Input :disabled="ifViewStation" v-model="StationForm.StationTel" placeholder="输入负责电话"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="营业时间" prop="BusinessHours">
						<Input :disabled="ifViewStation" v-model="StationForm.BusinessHours" placeholder="输入营业时间"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" style="margin-bottom: 10px;">
					<Col :span="8">
					<FormItem label="站点类型" prop="StationType">
						<Select :disabled="ifViewStation" placeholder="运营场站的类型" v-model="StationForm.StationType">
							<Option :value="1">公共</Option>
							<Option :value="50">个人</Option>
							<Option :value="100">公交</Option>
							<Option :value="101">环卫</Option>
							<Option :value="102">物流</Option>
							<Option :value="103">出租车</Option>
							<Option :value="255">其它</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="站点属性" prop="StationProperty">
						<Select :disabled="ifViewStation" placeholder="运营场站的属性" v-model="StationForm.StationProperty">
							<Option :value="1">汽车充电站</Option>
							<Option :value="2">电单车充电站</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="关联道闸" prop="ParkingDeduction">
						<Select :disabled="ifViewStation" placeholder="关联道闸" v-model="StationForm.ParkingDeduction">
							<Option :value="0">未配置</Option>
							<Option v-bind:key="item.Id" v-for="(item) in StationParkingList" :value="item.Id">{{item.Name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="设备前置" prop="ChargeFronter">
						<Select :disabled="ifup || ifViewStation" placeholder="设备前置所属前置机" v-model="StationForm.ChargeFronter">
							<Option v-bind:key="item.Id" v-for="(item) in ChargeFronterList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="地锁前置" prop="ParkingLockFronter">
						<Select :disabled="ifViewStation" placeholder="地锁前置所属前置机" v-model="StationForm.ParkingLockFronter">
							<Option :value="0">未配置</Option>
							<Option v-bind:key="item.Id" v-for="(item) in ChargeFronterList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="行政区域编码" prop="AreaCode">
						<Input :disabled="ifViewStation" v-model="StationForm.AreaCode" placeholder="输入行政区域编码"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="详细地址" prop="Address">
						<Input :disabled="ifViewStation" v-model="StationForm.Address" placeholder="输入详细地址"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="站点引导" prop="SiteGuide">
						<Input :disabled="ifViewStation" v-model="StationForm.SiteGuide" placeholder="输入站点引导"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="经度" prop="Longitude">
						<Input :disabled="ifViewStation" v-model.number="StationForm.Longitude" placeholder="输入经度"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="纬度" prop="Latitude">
						<Input :disabled="ifViewStation" v-model.number="StationForm.Latitude" placeholder="输入纬度"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem :label-width="0">
						<Button :disabled="ifViewStation" type="warning" size="small" @click="mapOpen">地图选点</Button>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="充电费率描述" prop="ElectricityFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ElectricityFee" placeholder="输入充电电费率"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="服务费率描述" prop="ServiceFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ServiceFee" placeholder="输入服务费率"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="停车费率描述" prop="ParkFee">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkFee" placeholder="输入停车费"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="适用车型描述" prop="MatchCar">
						<Input :disabled="ifViewStation" v-model="StationForm.MatchCar" placeholder="适用车型描述"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="车位楼层及数量描述" prop="ParkInfo">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkInfo" placeholder="输入车位楼层及数量描述"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="车位数量" prop="ParkNum">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkNum" placeholder="输入车位数量"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="建设场所" prop="Construction">
						<Select :disabled="ifViewStation" placeholder="运营场站的属性" v-model="StationForm.Construction">
							<Option :value="1">居民区其他</Option>
							<Option :value="2">公共机构</Option>
							<Option :value="3">企事业单位</Option>
							<Option :value="4">写字楼</Option>
							<Option :value="5">工业园区</Option>
							<Option :value="6">交通枢纽</Option>
							<Option :value="7">大型文体设施</Option>
							<Option :value="8">城市绿地</Option>
							<Option :value="9">大型建筑配建停车场</Option>
							<Option :value="10">路边停车位</Option>
							<Option :value="11">城际高速服务区</Option>
							<Option :value="255">其他</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="停车场产权方" prop="ParkOwner">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkOwner" placeholder="停车场产权方"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="停车场管理方" prop="ParkManager">
						<Input :disabled="ifViewStation" v-model="StationForm.ParkManager" placeholder="停车场管理方"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="设备所属运营商ID" prop="EquipmentOwnerId">
						<Input :disabled="ifViewStation" v-model="StationForm.EquipmentOwnerId" placeholder="输入设备所属方ID"></Input>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="运营场站的属性" prop="ParkOpratorType">
						<Select :disabled="ifViewStation" placeholder="运营场站的属性" v-model="StationForm.ParkOpratorType">
							<Option :value="1">由本运营商自营</Option>
							<Option :value="2">由本运营商代运营</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="占位费价格" prop="Construction">
						<Select :disabled="ifViewStation" placeholder="占位费价格" v-model="StationForm.OccupyPrice">
							<Option :value="0">免费</Option>
							<Option v-bind:key="item.Id" v-for="(item) in occupyPriceList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="16">
					<FormItem label="备注" prop="Remark">
						<Input :disabled="ifViewStation" v-model="StationForm.Remark" placeholder="备注"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="是否对外运营" prop="IsOpen">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.IsOpen"
							size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="是否全天开放" prop="ParkOpenAllDay">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.ParkOpenAllDay"
							size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="是否支持扫码充电" prop="IsScanCode">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.IsScanCode"
							size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15">
					<Col :span="8">
					<FormItem label="是否免费停车" prop="ParkFree">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.ParkFree"
							size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="是否支持钱包支付" prop="SupportWalletPayment">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0'
							v-model="StationForm.SupportWalletPayment" size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="8">
					<FormItem label="是否支持预约" prop="SupportOrder">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="StationForm.SupportOrder"
							size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="15" v-if="false">
					<Col :span="24">
					<FormItem label="支付方式" prop="PaymentMode">
						<!-- <Input v-model="StationForm.PaymentMode" placeholder="输入支付方式"></Input> -->
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod1" size="large">
							<span slot="open">离线卡</span>
							<span slot="close">离线卡</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod2" size="large"
							style="margin-left: 15%;">
							<span slot="open">在线卡</span>
							<span slot="close">在线卡</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod3" size="large"
							style="margin-left: 15%;">
							<span slot="open">支付宝</span>
							<span slot="close">支付宝</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod4" size="large"
							style="margin-left: 15%;">
							<span slot="open">微信</span>
							<span slot="close">微信</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>

			</Form>
			<div v-if="modal.type=='addStation'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='updateStation'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='viewStation'" slot="footer">
			</div>
		</Modal>
		<Modal :z-index="zindex" :mask-closable="false" v-model="showMap" :title="modal.Title" @on-ok="closeMap(true)"
			@on-cancel="closeMap(false)" width="70%">
			<div class="map-input">
				<Input class="lnglat" v-model="mapLng" disabled placeholder="经度" />
				<Input class="lnglat" v-model="mapLat" disabled placeholder="纬度" />
				<Input class="search" search enter-button="查找" v-model="inputCity" @on-search="searchCity"
					placeholder="输入选择城市" />
			</div>
			<div id="map" style="width: 100%;height: 500px;margin-top: 5px;">
			</div>
			<!-- <div slot="footer">
				<Button type="success" size="small" @click="closeMap">确定</Button>
			</div> -->
		</Modal>
		<!-- <Modal v-model="showMechant" title="Common Modal dialog box title">
			<p>Content of dialog</p>
			<p>Content of dialog</p>
			<p>Content of dialog</p>
		</Modal> -->
		<Modal v-model="showMechant" title="分配收款商户" @on-ok="assignMerchant" :mask-closable="false">
			<Form label-position="right" :label-width="100" ref="StationMerchantForm" :model="StationMerchantForm">
				<FormItem label="收款商户" prop="CollectionMch">
					<Select placeholder="收款商户" v-model="StationMerchantForm.CollectionMch">
						<Option v-bind:key="0" :value="0">未分配</Option>
						<Option v-bind:key="item.Id" v-for="(item) in PayeeMerchant" :value="item.Id">{{item.Name}}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="showEvcs" title="分配互联互通" @on-ok="assignEvcs" :mask-closable="false">
			<Form label-position="right" :label-width="110" ref="StationEvcsForm" :model="StationEvcsForm">
				<FormItem label="互联互通运营商" prop="EvcsOperators">
					<Select placeholder="互联互通运营商" multiple v-model="StationEvcsForm.EvcsOperatorArray">
						<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in EvcsOperators" :value="item.Id">{{item.Name}}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './StationManagementExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import MapObj from '@/js/TMap.js';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	import commonFuncs from '../../../js/commonFuncs.js';
	export default {
		data() {
			return {
				getStationInfoUrl: webapi.base_api_url + '/Archives/GetStationInfo',
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				occupyPriceList: [],
				zindex: 2000,
				loadingStatus: false,
				mapInst: null,
				mapLng: 0,
				mapLat: 0,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "场站添加",
					type: "addStation"
				},
				modalView: false,

				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存，实际点击保存才删除
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				/******分割线********/

				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				inputCity: '深圳',
				//字段显示
				ifAddStation: true,
				//修改主键只能查
				ifup: false,
				//场站信息是否只能查看
				ifViewStation: false,

				showMechant: false,
				showEvcs: false,

				EvcsOperators: [],
				//档案-场站管理全部信息
				StationForm: {
					//前八个是某系整数结果代表什么意思的描述  用来配合显示
					StationTypeDesc: "公共",
					StationStatusDesc: "正常使用",
					StationPicturesArray: [],
					ConstructionDesc: "大型建筑配建停车场",
					ParkOpratorTypeDesc: "由本运营商自营",
					EvcsOperatorArray: [],
					Creator: "",
					Modifier: "",

					EquipmentNum: 0,
					ConnectorNum: 0,

					Id: 0,
					StationCode: "",
					StationName: "",
					OperatorId: "",
					OperatorName: "",
					EquipmentOwnerId: "",
					CountryCode: "",
					AreaCode: "",
					Address: "",
					StationTel: "",
					ServiceTel: "",
					StationType: 1,
					StationProperty: 1,
					ChargeFronter: 0,
					StationStatus: 50,
					ParkNum: 0,
					Longitude: 0,
					Latitude: 0,
					SiteGuide: "",
					Construction: 9,
					StationPictures: "",
					MatchCar: "",
					ParkInfo: "",
					BusinessHours: "00:00-24:00",
					ElectricityFee: "",
					ServiceFee: "",
					ParkFee: "",
					PaymentMode: 34,
					SupportOrder: 0,
					QueryType: 8,
					Remark: "",
					ParkOwner: "",
					ParkManager: "",
					ParkOpenAllDay: 1,
					ParkFree: 0,
					ParkOpratorType: 1,
					IsOpen: 1,
					IsScanCode: 1,
					SupportWalletPayment: 0,
					DisparkDate: "",
					CollectionMch: 0,
					EvcsOperators: "",
					CreateBy: 0,
					CreateTime: "",
					ModifyBy: 0,
					ModifyTime: ""
				},
				StationMerchantForm: {},
				StationEvcsForm: {},
				//校验字段
				ruleInline: {
					StationName: [{
						required: true,
						message: '请输入充电站名称',
						trigger: 'blur'
					}],
					OperatorId: [{
						required: true,
						message: '运营商ID',
						trigger: 'blur',
					}],
					StationTel: [{
						required: true,
						message: '请输入负责人电话',
						trigger: 'blur'
					}],
					ServiceTel: [{
						required: true,
						message: '请输入服务电话',
						trigger: 'blur'
					}],
					StationType: [{
						required: true,
						message: '站点类型',
						trigger: 'change',
						type: 'number'
					}],
					StationProperty: [{
						required: true,
						message: '站点属性',
						trigger: 'change',
						type: 'number'
					}],
					ChargeFronter: [{
						required: true,
						message: '设备前置',
						trigger: 'charge',
						type: 'number',
						min: 1,
					}],
					OperatorName: [{
						required: true,
						message: '供应商名称',
						trigger: 'change',
					}],
					AreaCode: [{
						required: true,
						message: '请输入行政区域编码',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
					Longitude: [{
						required: true,
						message: '经度',
						trigger: 'blur',
						type: 'number',
					}],
					Latitude: [{
						required: true,
						message: '纬度',
						trigger: 'blur',
						type: 'number'
					}],
					BusinessHours: [{
						required: true,
						message: '营业时间',
						trigger: 'blur'
					}]
				},
				BreadcrumbList: ['档案管理', '>>', '场站管理'],
				formInline: {
					StationId: 0,
					StationName: ''
				},
				operateColumnWidth: 30,

				//table标题数据
				columns1: [{
						title: '站点名称',
						key: 'StationName',
						minWidth: 150
					}, {
						title: '详细地址',
						key: 'Address',
						minWidth: 200
					},
					{
						title: '电桩数量',
						key: 'EquipmentNum',
						minWidth: 100
					},
					{
						title: '枪口数量',
						key: 'ConnectorNum',
						minWidth: 100
					},
					// {
					// 	title: '建档时间',
					// 	key: 'CreateTime',
					// 	minWidth: 200
					// },
					{
						title: '上线时间',
						key: 'DisparkDate',
						minWidth: 200
					},
					{
						title: '站点类型',
						key: 'StationType',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.StationTypeDesc
							);
						}
					},
					{
						title: '站点状态',
						key: 'StationStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.StationStatusDesc
							);
						}
					},
					{
						title: '服务电话',
						key: 'ServiceTel',
						minWidth: 120
					},
					{
						title: '营业时间',
						key: 'BusinessHours',
						minWidth: 150
					},
					// {
					// 	title: '经纬度',
					// 	key: 'LatLng',
					// 	render: (h, params) => {
					// 		return h('div', params.row.Longitude + ',' + params.row.Latitude);
					// 	}
					// },
					{
						title: '运营商名称',
						key: 'OperatorName',
						minWidth: 200
					}, {
						title: '操作',
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px',
									},
									on: {
										click: () => {
											this.show("updateStation", params.row.Id)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("viewStation", params.row.Id)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看') : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
									'Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												if (name == '分配收款商户') {
													this.StationMerchantForm.Id = params.row.Id;
													this.StationMerchantForm.CollectionMch = params.row
														.CollectionMch;
													this.showMechant = true;
													this.$nextTick(() => {
														this.StationMerchantForm.Id = params
															.row.Id;
														this.StationMerchantForm
															.CollectionMch = params.row
															.CollectionMch;
													})
													return;
												} else if (name == '分配互联互通') {
													this.StationEvcsForm.Id =
														params.row.Id;
													this.StationEvcsForm
														.EvcsOperatorArray = params
														.row.EvcsOperatorArray;
													this.StationEvcsForm
														.EvcsOperators = params.row
														.EvcsOperators;
													this.showEvcs = true;
													return;
												}
												this.$Modal.confirm({
													title: name,
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '其他操作'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name))
											.map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				methodList: [{
						id: 0,
						name: 'assignMerchant',
						Status: '分配收款商户'
					}, {
						id: 0,
						name: 'assignEvcs',
						Status: '分配互联互通'
					},
					{
						id: 1,
						name: 'building',
						Status: '建设中'
					}, {
						id: 5,
						name: 'swithcOff',
						Status: '关闭下线'
					},
					{
						id: 6,
						name: 'maintaining',
						Status: '维护中'
					},
					{
						id: 50,
						name: 'running',
						Status: '正常使用',
					}
				],
				data1: [],

				payValue: 0,
				widgets: [],
			};
		},
		async created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight);
			// this.widgets = this.$route.meta.widgets;// await commonFuncs.getWidgetByMenuId(this.$route.meta.menuId);
			// this.widgets.push({Name: 'edit'});
			// this.widgets.push({Name: 'view'});
			// this.widgets.push({Name: 'running'});
			// console.log('widgets', this.widgets);
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			this.columns1.at(-1).minWidth = this.operateColumnWidth;
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
			this.GetChargeFronterList();
			this.getEvcsOperatorList();
			this.getOccupyPriceList();
			this.getStationParkingList();
			// console.log("useRoute", , this.$router.currentRoute, this.$route, this.$router);
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					StationName: _this.formInline.StationName,
				}
				return param
			},
			PayMethod1: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
					}
				}
			},
			PayMethod2: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
					}
				}
			},
			PayMethod3: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(1, 2))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
					}
				}
			},
			PayMethod4: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(0, 1))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
					}
				}
			},

			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatortypeList: 'typeList',
				ChargeFronterList: 'chargeFronterList',
				PayeeMerchant: 'PayeeMerchant',
				StationParkingList: 'StationParkingList',
			})
		},
		methods: {
			...mapActions([
				'GetUserStations',
				'GetChargeFronterList',
				'getStationParkingList'
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作按钮
			show: function(type, params) {
				switch (type) {
					case "addStation":
						this.modal.type = "addStation";
						this.modal.Title = "场站添加";
						this.ifup = false
						this.ifViewStation = false
						this.modalCancel();
						break;
					case "updateStation":
						this.modal.type = "updateStation";
						this.modal.Title = "场站信息修改";
						this.ifup = true
						this.getUpdateMessage(params);
						this.ifViewStation = false
						break;
					case "viewStation":
						this.modal.type = "viewStation";
						this.modal.Title = "场站信息查看";
						this.getUpdateMessage(params);
						this.ifup = true
						this.ifViewStation = true
						break;
				}
				this.modalView = true;

			},
			//modal取消操作
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("取消添加或跟新，删除添加的图片")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.SetStationStatus, {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(name + '成功');
						this.handleSubmit()
					}
				})
			},
			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.success('删除成功');
					}
				})
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				this.uploadList = []
				this.$nextTick(() => {
					this.$refs.StationForm.resetFields();
					this.$refs.upload.clearFiles();
					this.defaultList = this.$refs.upload.fileList
				})
			},
			getUpdateMessage: function(Id) {
				console.log(Id);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].Id == Id) {
						_this.StationForm = Object.assign({}, _this.data1[i])
						let picList = [];
						let arr = _this.data1[i].StationPicturesArray
						for (let i = 0; i < arr.length; i++) {
							let url = ''
							// if (process.env.NODE_ENV === "development") {
							// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
							// }else {
							//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
							// }
							url = webapi.base_api_url + arr[i];
							let picture = {
								name: arr[i],
								url: url
							}
							picList.push(picture)
						}
						_this.defaultList = picList
						_this.$nextTick(() => {
							// dom元素更新后执行，因此这里能正确打印更改之后的值
							_this.uploadList = _this.$refs.upload.fileList
						})
					}
				}
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.Id = 0
						break;
					case "up":
						let picsArr = _this.PictureUpCache
						if (picsArr.length > 0) {
							let StationPictures = ''
							for (let i = 0; i < picsArr.length; i++) {
								if (i == (picsArr.length - 1)) {
									StationPictures += picsArr[i]
								} else {
									StationPictures += picsArr[i] + ','
								}
							}
							_this.deletePicture(StationPictures)
						}
						break;
				}
				_this.PictureDelCache = [];
				_this.PictureUpCache = [];
				let picsArr = _this.StationForm.StationPicturesArray
				_this.StationForm.StationPictures = ''
				for (let i = 0; i < picsArr.length; i++) {
					if (i == (picsArr.length - 1)) {
						_this.StationForm.StationPictures += picsArr[i]
					} else {
						_this.StationForm.StationPictures += picsArr[i] + ','
					}
				}
				const param = _this.StationForm
				this.$refs.StationForm.validate((valid) => {
					console.log("场站" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddStation',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								this.$Message.success("场站" + type + "成功");
								this.$refs.sonPage.getList();
								this.modalView = false;
								this.GetUserStations()
							} else {
								this.$Message.error("场站" + type + "失败");
							}
						})
					}
				})
			},

			//地图modal
			mapOpen: function() {
				const _this = this;
				this.showMap = true;
				let latlng = [this.StationForm.Longitude, this.StationForm.Latitude];
				if (!this.StationForm.Longitude || !this.StationForm.Latitude) latlng = this.center;
				this.mapLng = this.StationForm.Longitude;
				this.mapLat = this.StationForm.Latitude;

				this.$nextTick(() => {
					// gaodeMap.initMap("map", 9, this.center, 'normal');
					// gaodeMap.mapOn2(this);
					// gaodeMap.createMarke(latlng)
					// if (this.StationForm.Latitude != 0) {
					// 	gaodeMap.map.setCenter(latlng)
					// }
					_this.mapInst = new MapObj(window.TMap);
					_this.mapInst.initMap('map', 10, latlng[0], latlng[1]);
					const markerId = 1;
					_this.mapInst.createMarker(markerId, latlng[0], latlng[1]);
					_this.mapInst.on('click', (evt) => {
						_this.mapInst.setMarkerPosition(markerId, evt.latLng.lng, evt.latLng.lat);
						this.mapLng = evt.latLng.lng;
						this.mapLat = evt.latLng.lat;
					})
				})
			},
			closeMap: function(result) {
				const _this = this;
				if (result) {
					this.StationForm.Longitude = this.mapLng;
					this.StationForm.Latitude = this.mapLat;
				}
				// gaodeMap.map.destroy();
				// gaodeMap.map = '';
				_this.mapInst.destroyMap();
				this.showMap = false;
			},
			searchCity: function() {
				const _this = this
				// _this.$axios.get('https://apis.map.qq.com/ws/geocoder/v1/?address=%E6%B7%B1%E5%9C%B3%E5%8C%97%E7%AB%99&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77')
				this.mapInst.geoCoder(_this.inputCity).then(res => {
					_this.StationForm.Longitude = res.result.location.lng;
					_this.StationForm.Latitude = res.result.location.lat;
					_this.mapInst.setCenter(_this.StationForm.Longitude, _this.StationForm.Latitude);
					_this.mapInst.setMarkerPosition(1, _this.StationForm.Longitude, _this.StationForm.Latitude);
				});
				// gaodeMap.geoCode(_this.inputCity).then(res => {
				// 	_this.StationForm.Latitude = res.getLat()
				// 	_this.StationForm.Longitude = res.getLng()
				// 	gaodeMap.mapOn2(_this)
				// 	gaodeMap.createMarke(res)
				// 	gaodeMap.map.setCenter(res)
				// 	//console.log(res)
				// })
			},
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.success('删除成功');
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.error('图片删除失败');
						_this.handleSubmit()
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')
				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					console.log(fileList)
					console.log(_this.$refs.upload.fileList)
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationForm.StationPicturesArray = _this.StationForm.StationPicturesArray.filter(function(item,
					index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }else {
					//   file.url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationForm.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '格式错误',
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '图片太大',
					desc: '文件' + file.name + ' 图片太大请选择小于 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				let Operatortype = this.OperatortypeList.filter(function(item, index, arr) {
					return item.Name == a
				})
				this.StationForm.OperatorId = Operatortype[0].Id;
			},
			getEvcsOperatorList: function() {
				this.$axios.post(webapi.base_api_url + '/Common/GetEvcsOperatorList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.EvcsOperators = res.data.Data.List;
					}
				})
			},
			assignMerchant: function() {
				const _this = this;
				console.log(this.StationMerchantForm);
				let param = {
					StationId: this.StationMerchantForm.Id,
					MerchantId: this.StationMerchantForm.CollectionMch,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignMerchant', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.success('分配成功');
					} else {
						_this.$Message.error('分配失败');
					}
				});
			},
			assignEvcs: function() {
				const _this = this;
				console.log(this.StationEvcsForm);
				let param = {
					StationId: this.StationEvcsForm.Id,
					EvcsOperatorIds: this.StationEvcsForm.EvcsOperatorArray,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignEvcs', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.success('分配成功');
					} else {
						_this.$Message.error('分配失败');
					}
				});
			},
			getOccupyPriceList: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Common/GetSelctListByType', {
					Type: 9
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.occupyPriceList = res.data.Data.List;
					}
				});
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 16px;
	}

	.ivu-form-item-error-tip {
		padding-top: 0;
	}

	/* 	.ivu-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
 */
	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.map-input {
		display: flex;
		flex-direction: row;
	}

	.map-input .lnglat {
		width: 90px;
	}

	.map-input .search {
		flex: 1;
	}
</style>